function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 2.856,
  y: 15.599,
  fill: "#E149A4",
  width: 4.202,
  height: 1.223
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.856,
  y: 12.605,
  fill: "#E149A4",
  width: 8.682,
  height: 1.223
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.856,
  y: 9.612,
  fill: "#E149A4",
  width: 8.682,
  height: 1.223
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E149A4",
  d: "M12.255,0H2.931v1.739h1.223V1.223h7.239l4.063,4.063v10.883h-0.517v1.224h1.739V4.382L12.255,0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E149A4",
  d: "M9.646,2.608H0.322V20h13.746V6.99L9.646,2.608z M10.006,4.696l1.976,1.975h-1.976V4.696z M1.545,18.777 V3.831h7.238v4.063h4.063v10.883H1.545z"
}));

var SvgDetalleSolRepoIcon = function SvgDetalleSolRepoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    enableBackground: "new 0 0 17 20",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetalleSolRepoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/detalleSolRepo_icon.7b694eda.svg";
export { ForwardRef as ReactComponent };